import { render, staticRenderFns } from "./FlowerJoyConfig.vue?vue&type=template&id=166b1cfa&scoped=true"
import script from "./FlowerJoyConfig.vue?vue&type=script&lang=js"
export * from "./FlowerJoyConfig.vue?vue&type=script&lang=js"
import style0 from "./FlowerJoyConfig.vue?vue&type=style&index=0&id=166b1cfa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166b1cfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('166b1cfa')) {
      api.createRecord('166b1cfa', component.options)
    } else {
      api.reload('166b1cfa', component.options)
    }
    module.hot.accept("./FlowerJoyConfig.vue?vue&type=template&id=166b1cfa&scoped=true", function () {
      api.rerender('166b1cfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mealOrder/mealView/mealConfig/components/FlowerJoyConfig.vue"
export default component.exports